import dayjs from "dayjs";
import utc from "dayjs/plugin/utc"; // Import the UTC plugin

dayjs.extend(utc); // Extend dayjs with the plugin

export const formatDate = (dateString) => {
    if (!dateString) return "";
    return dayjs.utc(dateString).format("MM-DD-YYYY");
};

export const isDateValue = (val) => {
    // Simple check: string and can be parsed as date and not NaN
    return (
        typeof val === "string" &&
        !isNaN(Date.parse(val)) &&
        (val.includes("-") || val.includes("/"))
    );
};

export const toUTCDate = (dateString) => {
    debugger
    if (!dateString) return null;
    // Handle MM/DD/YYYY and YYYY-MM-DD
    let year, month, day;
    if (dateString.includes("/")) {
        // MM/DD/YYYY
        [month, day, year] = dateString.split("/");
    } else if (dateString.includes("-")) {
        // YYYY-MM-DD
        [year, month, day] = dateString.split("-");
    }
    // Create a UTC date string
    const utcDate = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day)));
    return utcDate.toISOString();
};